// extracted by mini-css-extract-plugin
export default {"fullnameLabel":"Drivers_fullnameLabel__ARNsP","fullnameLabelText":"Drivers_fullnameLabelText__axiNo"};